import React from 'react';
import { Button } from 'components';
import styles from './CheckBox.module.scss';

interface Props {
  onClick?: () => void;
  checked?: boolean;
  label?: string;
  className?: string;
  status?: string;
}

const CheckBox = (props: Props) => {
  const { label, checked, onClick, className, status } = props;
  const containerStylesArr = [styles.container];
  className && containerStylesArr.push(className);

  const getStatusSymbol = () => {
    switch (status) {
      case 'unchecked': return '';
      case 'checked': return '✓';
      case 'allChildrenAreChecked': return <span className={styles.partiallyChecked}>■</span>;
      case 'partiallyChecked': return '–';
      default: return '';
    }
  };

  return (
    <Button
      className={containerStylesArr.join(' ')}
      onClick={onClick}
    >
      <span className={styles.checkBox}>{
        status
          ? getStatusSymbol()
          : checked ? '✓' : ''
        // checked ? '✓' : '–'
      }</span>
      {label}
    </Button>
  );
};

export default CheckBox;
